import { render } from "./InitTel.vue?vue&type=template&id=0d5a67a2&scoped=true"
import script from "./InitTel.vue?vue&type=script&lang=ts"
export * from "./InitTel.vue?vue&type=script&lang=ts"

import "./InitTel.vue?vue&type=style&index=0&id=0d5a67a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d5a67a2"

export default script